import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Hook that provides access to auth state without triggering additional API calls.
 * Components should use this hook instead of calling supabase.auth directly.
 * 
 * @returns The current user and session state from AuthContext
 */
export function useAuthState() {
  const authContext = useAuth();
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  
  // Return initial state if not mounted yet
  if (!mounted) {
    return {
      user: null,
      isAuthenticated: false,
      isLoading: true
    };
  }
  
  return {
    user: authContext.user,
    isAuthenticated: !!authContext.user,
    isLoading: authContext.loading
  };
} 